import { create, StateCreator } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'

import { IAppState } from './appStore.types'


// Change for IAppPersistentState when there will be more persistent data
const initialState: IAppState = {
    searchParams: {
        ref_code: null,
        companyInviteId: null,
        signup_origin_domain: null,
        signup_origin_path: null,
        landing_page: null,
        referrer: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_content: null,
        utm_term: null,
    },
}

export interface IAppPersistentStore extends IAppState {
    setSearchParams: (searchParams: Partial<IAppState['searchParams']>) => void

    reset: () => void
}

const createAppPersistentStore: StateCreator<
    IAppPersistentStore,
    [['zustand/persist', unknown], ['zustand/devtools', never]]
> = (set) => ({
    ...initialState,
    setSearchParams: (searchParams: Partial<IAppState['searchParams']>) =>
        set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    ...searchParams,
                },
            }),
            undefined,
            'appPersistentStore/setSearchParams'
        ),
    reset: () => set({ ...initialState }, undefined, 'appPersistentStore/reset'),
})

const useAppPersistentStore = create<IAppPersistentStore>()(
    persist(
        devtools(createAppPersistentStore, { name: 'AppPersistentStore' }),
        {
            name: 'app-persistent-store',
            storage: createJSONStorage(() => localStorage),
        }
    )
)

export default useAppPersistentStore
